<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">Seasonal Parking</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'seasonalParking', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Seasonal Parking
            </span>
          </router-link>
        </li>
      </ul>

      <div v-if="sum > 0" class="btn btn-group m-btn-group" slot="actions">
        <button class="btn btn-default" disabled>
          KES {{ formatNumber(sum) }}
        </button>
        <button class="btn btn-success" @click="showPayModal" :disabled="sum === 0">
          Pay
        </button>
      </div>
    </bread-crumb>
    <dash-content>
      <div id="seasonal-parking" v-if="showVehicles" slot="content">
        <modal @closeModal="closeModal" v-if="showVehiclePayHistoryModal" size="modal-lg">
          <div slot="header">
            <h4 class="modal-title">Vehicle Payment History</h4>
          </div>
          <div slot="body">
            <vehicle-payment-history :vehicle-id="vehicleId"></vehicle-payment-history>
          </div>
        </modal>
        <payment v-if="showPaymentModal" @closePaymentModal="closePaymentModal" :transaction-details="transactionDetails" card-tx-type="pay-for-vehicles-card" mpesa-tx-type="pay-for-vehicles">
          <table slot="items" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <strong>Item</strong>
                </th>
                <th>
                  <strong>Amount</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Seasonal Parking</td>
                <td>KES {{ sum }}</td>
              </tr>
              <tr>
                <td>
                  <strong>TOTAL</strong>
                </td>
                <td>
                  <strong>KES {{ sum }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </payment>
        <ul class="nav nav-tabs m--margin-0" role="tablist">
          <li class="nav-item" role="presentation">
            <a data-toggle="tab" href="#tab1" class="nav-link active">
              Vehicles
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a data-toggle="tab" href="#tab2" class="nav-link">
              Payment History
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="tab1" role="tabm-portlet">
            <div class="row">
              <div class="col-md-8">
                <div class="m-portlet">
                  <div class="m-portlet__body">
                    <div class="row">
                      <label class="col-md-5 m--padding-left-25 m--margin-top-5">
                        Select Subcounty
                      </label>
                      <div class="col-md-7">
                        <select class="form-control m-input" v-model="subCountyId" @change="subCountyChange">
                          <option v-for="subCounty in subCounties" :value="subCounty.id" :key="subCounty.id">
                            {{ subCounty.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <table class="table table-striped table-bordered m--margin-top-15">
                      <thead>
                        <tr>
                          <th>
                            <label class="m-checkbox">
                              <input v-model="allSelected" @change="selectAll" type="checkbox">
                              <span></span>
                            </label>
                          </th>
                          <th>Registration No.</th>
                          <th>Sacco</th>
                          <th>Capacity</th>
                          <th>Arrears</th>
                          <th>Service Charge</th>
                          <th>Month(s)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(vehicle, key) in vehicles" :key="key">
                          <td>
                            <label class="m-checkbox">
                              <input :value="vehicle" v-model="selectedVehicles" @change="vehicleChanged" type="checkbox">
                              <span></span>
                            </label>
                          </td>
                          <td>
                            <a @click="vehicleTransactionHistory(vehicle.id)" href="javascript: void(0)">{{ vehicle.regNo }}</a>
                          </td>
                          <td>{{ vehicle.sacco }}</td>
                          <td>{{ vehicle.capacity }}</td>
                          <td>KES {{ vehicle.arrears }}</td>
                          <td>KES {{ vehicle.serviceCharge }}</td>
                          <td>
                            <select style="width: 80px; height: 32px; font-size:12px" v-model="vehicle.noOfPeriods" @change="updateVehicle(vehicle)" class="form-control" type="text">
                              <option v-for="(i,key) in 7" :key="key" :value="i">{{ i }}</option>
                            </select>
                          </td>
                        </tr>
                        <tr v-if="vehicles.length === 0">
                          <td colspan="9">No vehicles to display.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <instructions>
                  <ol slot="instructions">
                    <li>Select sub-county</li>
                    <li>Select the vehicle registration number</li>
                    <li>Select the number of months you want to pay for</li>
                    <li>Click on Pay to procced</li>
                  </ol>
                </instructions>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="tab2">
            <div class="m-portlet">
              <div class="m-portlet__body">
                <payment-history :data="payments"></payment-history>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dash-content>
  </div>
</template>

  <script>
import api from "../../../api";
import helper from "../../../helpers";
import Modal from "../../Modal";
import BreadCrumb from "../../partials/BreadCrumb";
import Instructions from "../../partials/Instructions";
import dashContent from "../../partials/Content";
import payment from "../../checkout/Payment";
import vehiclePaymentHistory from "./datatables/VehiclePaymentHistory";
import paymentHistory from "./datatables/PaymentHistory";

export default {
  name: "SeasonalParking",
  data() {
    return {
      token: this.$store.state.token || window.localStorage.getItem("token"),
      params: this.$route.params,
      countyId: this.$route.params.countyId,
      subCounties: "",
      allSelected: false,
      subCountyId: "",
      vehicles: [],
      showPaymentModal: false,
      showVehiclePayHistoryModal: false,
      selectedVehicles: [],
      allVehicles: [],
      showVehicles: false,
      sum: 0,
      payments: [],
      transactionDetails: {},
      vehicleId: ""
    };
  },
  components: {
    Modal,
    BreadCrumb,
    Instructions,
    payment,
    dashContent,
    vehiclePaymentHistory,
    paymentHistory
  },
  methods: {
    getSubCountyVehicles(subCountyId) {
      this.vehicles = [];
      for (let vehicle of this.allVehicles) {
        for (let paymentData of vehicle.paymentData) {
          if (paymentData.subCounty === subCountyId) {
            let vehicleDetails = {
              id: vehicle.id,
              regNo: vehicle.regNo,
              capacity: vehicle.capacity,
              lastPayDate: paymentData.lastPayDate,
              validUntil: paymentData.validUntil,
              lastPaidAmount: paymentData.lastPaidAmount,
              arrears: paymentData.arrears,
              serviceCharge: paymentData.serviceCharge,
              subCounty: subCountyId,
              sacco: vehicle.sacco,
              noOfPeriods: 1
            };
            this.vehicles.push(vehicleDetails);
            // Update noOfPeriods if in selected
            if (this.selectedVehicles.length > 0) {
              for (let vehicle of this.selectedVehicles) {
                if (
                  vehicleDetails.subCounty === vehicle.subCounty &&
                  vehicleDetails.regNo === vehicle.regNo
                ) {
                  vehicleDetails.noOfPeriods = vehicle.noOfPeriods;
                  break;
                }
              }
            }
            break;
          }
        }
      }
    },
    closeModal() {
      document.body.classList.remove("modal-open");
      this.showVehiclePayHistoryModal = false;
      this.showTransactionDetailsModal = false;
      this.vehicleId = "";
    },
    getVehicles() {
      this.getSubCountyVehicles(this.subCountyId);
    },
    calculateSum() {
      this.sum = 0;
      for (let vehicle of this.selectedVehicles) {
        this.sum =
          Number(this.sum) +
          Number(vehicle.arrears) +
          Number(vehicle.serviceCharge * vehicle.noOfPeriods);
      }
    },
    updateVehicle(vehicleDetail) {
      for (let vehicle of this.selectedVehicles) {
        if (
          vehicleDetail.subCounty === vehicle.subCounty &&
          vehicleDetail.regNo === vehicle.regNo
        ) {
          vehicle.noOfPeriods = vehicleDetail.noOfPeriods;
          this.calculateSum();
        }
      }
    },
    formatNumber(x) {
      return helper.formatNumber(x);
    },
    vehicleTransactionHistory(vehicleId) {
      this.vehicleId = vehicleId;
      this.showVehiclePayHistoryModal = true;
      document.body.classList.add("modal-open");
    },
    loadVehicles() {
      const txType = "get-vehicles";
      let data = {
        token: this.token,
        countyId: this.countyId
      };
      helper.loading(true);
      api
        .request(txType, data)
        .then(response => {
          if (response.data.status === "00") {
            helper.loading(false);
            this.subCounties = response.data.subCounties;
            this.subCountyId = response.data.subCounties[0].id;
            this.allVehicles = response.data.vehicles;
            this.getSubCountyVehicles(this.subCountyId);
            this.showVehicles = true;
          } else {
            helper.info({
              show: true,
              message: response.data.message
            });
            this.showVehicles = false;
          }
        })
        .catch(error => {
          helper.error({
            show: true,
            message: "An error occured. Please try again later."
          });
          console.log(error);
        });
    },
    loadPayHistory() {
      const txType = "get-customer-payment-history-seasonal-parking";
      let data = {
        token: this.token,
        countyId: this.countyId
      };
      api
        .request(txType, data)
        .then(response => {
          if (response.data.status === "00") {
            this.payments = response.data.paymentHistory;
          } else {
            console.log(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showPayModal() {
      if (this.selectedVehicles.length === 0) {
        helper.errorAlert("Please select at least one vehicle");
        return false;
      }
      let vehicles = [];
      for (let vehicle of this.selectedVehicles) {
        vehicles.push({
          id: vehicle.id,
          totalAmount: String(
            Number(vehicle.arrears) +
              Number(vehicle.serviceCharge * vehicle.noOfPeriods)
          ),
          noOfPeriods: String(vehicle.noOfPeriods),
          subCounty: vehicle.subCounty
        });
      }
      this.transactionDetails = {
        token: this.token,
        countyId: this.countyId,
        moduleId: String(helper.getModuleId("Periodic").id),
        totalAmount: String(this.sum),
        vehicles: vehicles
      };

      document.body.classList.add("modal-open");
      this.showPaymentModal = true;
    },
    closePaymentModal() {
      document.body.classList.remove("modal-open");
      this.showPaymentModal = false;
      this.loadVehicles();
      this.loadPayHistory();
      this.transactionDetails = {};
      this.selectedVehicles = [];
      this.sum = 0;
    },
    subCountyChange() {
      this.getVehicles();
      this.checkAllSelected();
    },
    vehicleChanged() {
      this.checkAllSelected();
      this.calculateSum();
    },
    checkAllSelected() {
      let eligibleVehicles = this.selectedVehicles.filter(vehicle => {
        if (vehicle.subCounty === this.subCountyId) {
          return vehicle;
        }
      });
      let subCountyVehicles = this.vehicles.filter(vehicle => {
        if (vehicle.subCounty === this.subCountyId) {
          return vehicle;
        }
      });
      if (eligibleVehicles.length === subCountyVehicles.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    selectAll() {
      if (this.allSelected) {
        for (let vehicle of this.vehicles) {
          if (vehicle.subCounty === this.subCountyId) {
            this.selectedVehicles.push(vehicle);
          }
        }
      } else {
        let eligibleVehicles = this.selectedVehicles.filter(vehicle => {
          if (vehicle.subCounty !== this.subCountyId) {
            return vehicle;
          }
        });
        this.selectedVehicles = eligibleVehicles;
      }
      this.calculateSum();
    },
    toggleSelectAll() {
      let eligibleBillboards = this.billboards.filter(billboard => {
        if (billboard.balance > "0") {
          return billboard;
        }
      });
      if (eligibleBillboards.length === this.selectedBillBoards.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    }
  },
  created: function() {
    this.loadVehicles();
    this.loadPayHistory();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/services/seasonal_parking/SeasonalParking.vue